const com70 = {
    code: "70",

    length: {variable: true},
    payload: [
        {name: "código", type: "bytes", length: 1, description: "Código de configuración (1 byte).", pad: "00"},
        {
            name: "protocolo",
            type: "string",
            description:
                "Protocolo utilizado para la comunicación. '-1' permite mandar el mensaje sin modificar la dirección del servidor",
            values: ["MQTT", "MQTTS"],
        },
        {
            name: "servidor",
            type: "string",
            description: "Dirección del servidor MQTT. '-1' permite mandar el mensaje sin modificar el puerto del servidor",
            special: ["-1"],
        },
        {
            name: "puerto_servidor",
            type: "string",
            description: "Puerto del servidor MQTT",
            range: {min: 0, max: 65535},
            special: ["-1"],
            pad: "0000000000",
        },
        {
            name: "usuario",
            type: "string",
            description:
                "Usuario de conexión MQTT. '-1' permite mandar el mensaje sin modificar el usuario. '' permite configurar la conexión sin usuario",
            special: ["-1", ""],
        },
        {
            name: "password",
            type: "string",
            description:
                "Password de conexión MQTT. '-1' permite mandar el mensaje sin modificar el password. '' permite configurar la conexión sin password",
            special: ["-1", ""],
        },
        {
            name: "cod_cliente_proyecto",
            type: "string",
            description:
                "Cliente-proyecto a la que enviar información. '-1' permite mandar el mensaje sin modificar el código de cliente-proyecto",
            special: ["-1"],
        },
        {
            name: "topic_UL_datos",
            type: "string",
            description:
                "Topic para realizar el envío de mediciones. '-1' permite mandar el mensaje sin modificar el topic UL_datos",
            special: ["-1"],
        },
        {
            name: "topic_UL_alertas",
            type: "string",
            description:
                "Topic para realizar el envío de alertas. '-1' permite mandar el mensaje sin modificar el topic UL_alertas",
            special: ["-1"],
        },
        {
            name: "topic_control",
            type: "string",
            description:
                "Topic para subidas y bajadas de mensajes de control. '-1' permite mandar el mensaje sin modificar el topic de control",
            special: ["-1"],
        },
        {
            name: "topic_admin",
            type: "string",
            description:
                "Topic para subidas y bajadas de mensajes de administración. '-1' permite mandar el mensaje sin modificar el topic de administración",
            special: ["-1"],
        },
    ],
};

export default com70;
